// d3 loads on first use (only the timeline draws with it).
let d3Loading = null
function loadD3() {
  d3Loading ||= import("d3").then((module) => { window.d3 = module })
  return d3Loading
}

function initializeCaseTimeline() {
  if (!document.getElementById("case_documents_chart_payload")) return;
  if (!document.getElementById("progress_d3_timeline_visual")) return;
  if (!window.d3) {
    loadD3().then(initializeCaseTimeline).catch((error) => console.error("Timeline library failed to load", error));
    return;
  }

  (function() {
      var d3 = window.d3;
      var AGGREGATE_CONFIG = [
        { key: 'communication', label: 'COMMUNICATION', color: '#6D28D9' },
        { key: 'request', label: 'REQUEST', color: '#2c3839' },
        { key: 'response', label: 'RESPONSE', color: '#202c2d' },
        { key: 'legal', label: 'LEGAL', color: '#174A7C' },
        { key: 'board_policy', label: 'BOARD POLICY', color: '#384445' }
      ];
      var LEGACY_AGGREGATE_BY_TYPE = {
        email_sent: 'communication',
        email_received: 'communication',
        counsel_comms: 'communication',
        attachment_sent: 'legal',
        attachment_received: 'legal',
        evidence: 'legal',
        board_docs: 'board_policy',
        formal_submission: 'request',
        response_rebuttal_sent: 'request',
        formal_response: 'response',
        response_rebuttal_received: 'response',
        docket: 'legal'
      };
      var chartState = null;
      var tooltipNode = null;
      var resizeRenderTimeout = null;
  
      if (window.caseTimelineD3AbortController) {
        window.caseTimelineD3AbortController.abort();
      }
      if (window.caseTimelineD3ResizeTimeout) {
        window.clearTimeout(window.caseTimelineD3ResizeTimeout);
        window.caseTimelineD3ResizeTimeout = null;
      }
      window.caseTimelineD3AbortController = window.AbortController ? new AbortController() : null;
      var abortSignal = window.caseTimelineD3AbortController && window.caseTimelineD3AbortController.signal;
  
      function addTimelineListener(target, eventName, handler, options) {
        if (!target || !target.addEventListener) return;
  
        var listenerOptions = options || {};
        if (abortSignal) listenerOptions = Object.assign({}, listenerOptions, { signal: abortSignal });
        target.addEventListener(eventName, handler, listenerOptions);
      }
  
      function escapeHtml(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }
  
      function truncateText(value, limit) {
        var text = String(value || '').replace(/\s+/g, ' ').trim();
        if (text.length <= limit) return text;
  
        var shortened = text.slice(0, limit).replace(/\s+\S*$/, '').trim();
        return (shortened || text.slice(0, limit).trim()) + '...';
      }
  
      function labelFromKey(value) {
        return String(value || 'Other').replace(/_/g, ' ').replace(/\b\w/g, function(match) {
          return match.toUpperCase();
        });
      }
  
      function normalizeKey(value) {
        return String(value || 'other').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '') || 'other';
      }

      function normalizeIdArray(value) {
        if (Array.isArray(value)) {
          return value.map(function(item) { return String(item || '').trim(); }).filter(Boolean);
        }
        if (value === null || typeof value === 'undefined' || value === '') return [];

        if (typeof value === 'string') {
          var trimmedValue = value.trim();
          if (!trimmedValue) return [];

          try {
            var parsedValue = JSON.parse(trimmedValue);
            if (Array.isArray(parsedValue)) return normalizeIdArray(parsedValue);
          } catch (error) {
            // Fall through to delimiter parsing for legacy string payloads.
          }

          return trimmedValue.split(/[,\s]+/).map(function(item) { return item.trim(); }).filter(Boolean);
        }

        return [String(value).trim()].filter(Boolean);
      }
  
      function getAggregateConfig(key) {
        return AGGREGATE_CONFIG.find(function(config) {
          return config.key === key;
        }) || AGGREGATE_CONFIG[0];
      }
  
      function aggregateKeyExists(key) {
        return AGGREGATE_CONFIG.some(function(config) {
          return config.key === key;
        });
      }
  
      function classLabelForEvent(eventData) {
        var classLabel = String(eventData.class_label || '').trim();
        if (classLabel) return classLabel;
        return eventData.category_label || labelFromKey(eventData.category);
      }
  
      function eventDisplayId(eventData) {
        if (!eventData) return '';
  
        var exhibitId = String(eventData.exhibit_id || '').trim();
        if (exhibitId) return exhibitId;
  
        var fallbackCodes = {
          docket: 'DKT',
          complaint: 'COM',
          motion: 'MOT',
          order: 'ORD',
          notice: 'NOT',
          application: 'APP',
          agreement: 'AGR',
          declaration: 'DEC',
          summons: 'SUM',
          response: 'RSP',
          request: 'REQ',
          email_received: 'EMR',
          email_sent: 'EMS'
        };
        var normalizedType = normalizeKey(eventData.category);
        var code = String(eventData.class_code || '').trim().toUpperCase();
        if (!code) code = fallbackCodes[normalizedType] || normalizedType.replace(/[^A-Z0-9]/gi, '').toUpperCase().slice(0, 3);
        if (!code) code = 'EVT';
  
        return code + '-' + String(eventData.sequence || eventData.id || '').padStart(3, '0');
      }
  
      function eventHaystack(eventData) {
        return [
          eventData.category,
          eventData.category_label,
          eventData.class_code,
          eventData.class_label,
          eventData.document_name,
          eventData.text
        ].join(' ').toLowerCase();
      }
  
      function aggregateCategoryForEvent(eventData) {
        var eventType = normalizeKey(eventData.category);
        if (aggregateKeyExists(eventType)) return eventType;
        if (LEGACY_AGGREGATE_BY_TYPE[eventType]) return LEGACY_AGGREGATE_BY_TYPE[eventType];
  
        var haystack = eventHaystack(eventData);
        if (/\bdkt\b|\bdocket\b|case no\.?|case number|cv-\d|united states district court|\bcourt\b|\bcomplaint\b|\bmotion\b|\bopposition\b|\breply\b|\border\b|\bstipulation\b|\bsummons\b|\bsubpoena\b|\bhearing\b/.test(haystack)) return 'legal';
        if (/\bboard policy\b|\bboard policies\b|\bboard\s+(?:meeting|workshop|agenda|minutes?|resolution)\b|\b(?:regular|special)\s+(?:board\s+)?meeting\b|\bboard of trustees\b|\btrustees?\b.*\b(?:agenda|meeting|policy|resolution|minutes?)\b|\b(?:bp|ar)\s*\d{3,5}(?:\.\d+)?\b|\bresolution\s+(?:no\.?|number)\b/.test(haystack)) return 'board_policy';
        if (/\brequest\b|\bdemand\b|\bferpa\b|\bcpra\b|\brecords request\b|\bconsent\b|\baccommodation\b|\bcorrection\b|\bproduction\b/.test(haystack)) return 'request';
        if (/\bresponse\b|\breply\b|\banswer\b|\bobjection\b|\bdenial\b|\bcompliance\b|\brebuttal\b/.test(haystack)) return 'response';
        if (/\bevidence\b|\bexhibit\b|\bdeclaration\b|\baffidavit\b|\btranscript\b|\brecord\b|\breport\b|\breceipt\b|\bproof\b|\bpolicy\b|\bresolution\b|\bminutes?\b|\bagenda\b|\bboard\b/.test(haystack)) return 'legal';
        return 'communication';
      }
  
      function inferParty(eventData) {
        var type = String(eventData.category || '');
        var haystack = [
          eventData.document_name,
          eventData.text,
          eventData.category_label
        ].join(' ').toLowerCase();
  
        if (type.indexOf('sent') !== -1 || type === 'formal_submission' || type === 'response_rebuttal_sent') return 'Requester';
        if (type === 'board_docs' || /district|board|trustees|superintendent/.test(haystack)) return 'Agency';
        if (type.indexOf('received') !== -1 || type === 'formal_response' || type === 'response_rebuttal_received' || /defendants?/.test(haystack)) return 'Respondent';
        return 'Requester';
      }
  
      function formatDateLabel(date) {
        if (!date || Number.isNaN(date.getTime())) return 'N/A';
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
      }
  
      function formatRangeLabel(domain) {
        if (!domain || domain.length < 2) return 'No data';
        return formatDateLabel(domain[0]) + ' - ' + formatDateLabel(domain[1]);
      }
  
      function setTimelineText(id, value) {
        var element = document.getElementById(id);
        if (element) element.textContent = value;
      }
  
      function loadTimelinePayload() {
        var payloadNode = document.getElementById('case_documents_chart_payload');
        if (!payloadNode) return [];
        var payloadText = timelinePayloadText(payloadNode);
  
        try {
          return JSON.parse(payloadText || '[]');
        } catch (error) {
          console.error('Failed to parse timeline payload', error);
          return [];
        }
      }

      function refreshTimelinePayloadFromServer(event) {
        var detail = event && event.detail ? event.detail : {};
        var container = document.getElementById('progress_container');
        var url = detail.timeline_payload_url || (container && container.dataset.timelinePayloadUrl);
        if (!url) return;

        window.fetch(url, {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function(response) {
            if (!response.ok) throw new Error('Timeline payload failed (' + response.status + ')');
            return response.json();
          })
          .then(function(payload) {
            var payloadNode = document.getElementById('case_documents_chart_payload');
            if (payloadNode) payloadNode.textContent = JSON.stringify(payload.events || []);

            setTimelineText('timeline_event_total_count', String(payload.event_count || 0));
            setTimelineText('timeline_total_associations', String(payload.association_count || 0));
            setTimelineText('timeline_date_range', payload.date_range || 'N/A');
            renderTimelineChart({ force: true });
          })
          .catch(function(error) {
            console.error('Timeline refresh failed', error);
          });
      }

      function timelinePayloadText(payloadNode) {
        if (!payloadNode) return '';
        if (payloadNode.content && payloadNode.content.textContent) return payloadNode.content.textContent;
        return payloadNode.textContent || '';
      }
  
      function normalizeEvent(rawEvent, index) {
        var timestamp = Number(rawEvent.timestamp);
        if (!Number.isFinite(timestamp)) timestamp = Date.parse(String(rawEvent.date || '') + 'T00:00:00Z');
        if (!Number.isFinite(timestamp)) timestamp = Date.now();
  
        var eventData = Object.assign({}, rawEvent, {
          id: rawEvent.id,
          idKey: String(rawEvent.id),
          timestamp: timestamp,
          dateObject: new Date(timestamp),
          cause_ids: normalizeIdArray(rawEvent.cause_ids),
          effect_ids: normalizeIdArray(rawEvent.effect_ids),
          sourceIndex: index
        });
        eventData.aggregateKey = aggregateCategoryForEvent(eventData);
        eventData.aggregate = getAggregateConfig(eventData.aggregateKey);
        eventData.displayId = eventDisplayId(eventData);
        eventData.classLabel = classLabelForEvent(eventData);
        eventData.party = inferParty(eventData);
        eventData.degree = eventData.cause_ids.length + eventData.effect_ids.length;
        return eventData;
      }
  
      function eventDateKey(eventData) {
        var explicitDate = String(eventData.date || '').trim().slice(0, 10);
        if (/^\d{4}-\d{2}-\d{2}$/.test(explicitDate)) return explicitDate;
        return eventData.dateObject.toISOString().slice(0, 10);
      }
  
      function dominantAggregateForEvents(events) {
        var counts = new Map();
        events.forEach(function(eventData) {
          counts.set(eventData.aggregateKey, (counts.get(eventData.aggregateKey) || 0) + 1);
        });
  
        return events.reduce(function(best, eventData) {
          if (!best) return eventData;
          return counts.get(eventData.aggregateKey) > counts.get(best.aggregateKey) ? eventData : best;
        }, null);
      }
  
      function categorySummaryForEvents(events) {
        var counts = new Map();
        events.forEach(function(eventData) {
          var label = eventData.classLabel || eventData.category_label || eventData.category || 'Other';
          counts.set(label, (counts.get(label) || 0) + 1);
        });
  
        return Array.from(counts.entries())
          .sort(function(a, b) { return b[1] - a[1] || a[0].localeCompare(b[0]); })
          .slice(0, 4)
          .map(function(entry) { return entry[0] + (entry[1] > 1 ? ' x' + entry[1] : ''); })
          .join(', ');
      }
  
      function groupedTextForEvents(events) {
        return events.slice(0, 5).map(function(eventData) {
          return eventData.displayId + ': ' + truncateText(eventData.text || eventData.document_name || eventData.classLabel, 95);
        }).join('; ');
      }
  
      function groupEventsByDate(sourceEvents) {
        var groupsByDate = new Map();
  
        sourceEvents.forEach(function(eventData) {
          var dateKey = eventDateKey(eventData);
          if (!groupsByDate.has(dateKey)) groupsByDate.set(dateKey, []);
          groupsByDate.get(dateKey).push(eventData);
        });
  
        return Array.from(groupsByDate.entries()).map(function(entry) {
          var dateKey = entry[0];
          var events = entry[1].sort(function(a, b) {
            if (a.timestamp !== b.timestamp) return a.timestamp - b.timestamp;
            return Number(a.id) - Number(b.id);
          });
          var firstEvent = events[0];
          var dominant = dominantAggregateForEvents(events) || firstEvent;
          var timestamp = Date.parse(dateKey + 'T00:00:00Z');
          var singleEvent = events.length === 1 ? firstEvent : null;
          var groupedEvent = Object.assign({}, singleEvent || dominant, {
            id: dateKey,
            idKey: 'date:' + dateKey,
            date: dateKey,
            timestamp: timestamp,
            dateObject: new Date(timestamp),
            sourceEvents: events,
            eventCount: events.length,
            associationCount: 0,
            internalAssociationCount: 0,
            aggregateKey: dominant.aggregateKey,
            aggregate: dominant.aggregate,
            classLabel: events.length === 1 ? firstEvent.classLabel : 'Grouped events',
            categorySummary: categorySummaryForEvents(events),
            displayId: events.length === 1 ? firstEvent.displayId : events.length + ' events',
            pointLabel: events.length === 1 ? firstEvent.displayId : String(events.length),
            party: events.length === 1 ? firstEvent.party : 'Mixed',
            text: events.length === 1 ? firstEvent.text : groupedTextForEvents(events),
            document_url: events.length === 1 ? firstEvent.document_url : null,
            document_name: events.length === 1 ? firstEvent.document_name : null
          });
  
          return groupedEvent;
        }).sort(function(a, b) {
          if (a.timestamp !== b.timestamp) return a.timestamp - b.timestamp;
          return a.idKey.localeCompare(b.idKey);
        });
      }
  
      function buildTimelineData() {
        var sourceEvents = loadTimelinePayload()
          .map(normalizeEvent)
          .sort(function(a, b) {
            if (a.timestamp !== b.timestamp) return a.timestamp - b.timestamp;
            return Number(a.id) - Number(b.id);
          });
        var events = groupEventsByDate(sourceEvents);
        var sourceEventsById = new Map();
        var groupsBySourceId = new Map();
        var groupsById = new Map();
        var associationKeys = new Set();
        var linkKeys = new Set();
        var links = [];
  
        events.forEach(function(eventData) {
          groupsById.set(eventData.idKey, eventData);
          eventData.sourceEvents.forEach(function(sourceEvent) {
            sourceEventsById.set(String(sourceEvent.id), sourceEvent);
            groupsBySourceId.set(String(sourceEvent.id), eventData);
          });
        });
  
        function addLink(sourceId, targetId) {
          var sourceEvent = sourceEventsById.get(String(sourceId));
          var targetEvent = sourceEventsById.get(String(targetId));
          var source = groupsBySourceId.get(String(sourceId));
          var target = groupsBySourceId.get(String(targetId));
          if (!sourceEvent || !targetEvent || !source || !target) return;
  
          var associationKey = String(sourceEvent.id) + '->' + String(targetEvent.id);
          if (associationKeys.has(associationKey)) return;
          associationKeys.add(associationKey);
  
          source.associationCount += 1;
          target.associationCount += 1;
  
          if (source.idKey === target.idKey) {
            source.internalAssociationCount += 1;
            return;
          }
  
          var key = source.idKey + '->' + target.idKey;
  
          if (linkKeys.has(key)) {
            var existing = links.find(function(link) { return link.id === key; });
            if (existing) {
              existing.count += 1;
              existing.sourceEvents.push(sourceEvent);
              existing.targetEvents.push(targetEvent);
            }
            return;
          }
  
          linkKeys.add(key);
          links.push({
            id: key,
            source: source,
            target: target,
            sourceEvents: [sourceEvent],
            targetEvents: [targetEvent],
            count: 1,
            color: source.aggregate.color
          });
        }
  
        sourceEvents.forEach(function(eventData) {
          eventData.cause_ids.forEach(function(causeId) {
            addLink(causeId, eventData.id);
          });
          eventData.effect_ids.forEach(function(effectId) {
            addLink(eventData.id, effectId);
          });
        });
  
        events.forEach(function(eventData) {
          eventData.degree = eventData.associationCount;
          eventData.clusterOffset = 0;
        });
        links.forEach(function(link, index) {
          link.routeIndex = index;
        });
  
        return { events: events, links: links, eventsById: groupsById, sourceEvents: sourceEvents };
      }
  
      function buildAdjacency(events, links) {
        var adjacency = new Map();
        events.forEach(function(eventData) {
          adjacency.set(eventData.idKey, new Set([eventData.idKey]));
        });
        links.forEach(function(link) {
          if (!adjacency.has(link.source.idKey)) adjacency.set(link.source.idKey, new Set([link.source.idKey]));
          if (!adjacency.has(link.target.idKey)) adjacency.set(link.target.idKey, new Set([link.target.idKey]));
          adjacency.get(link.source.idKey).add(link.target.idKey);
          adjacency.get(link.target.idKey).add(link.source.idKey);
        });
        return adjacency;
      }
  
      function focusedTimelineDomain(events, fullDomain) {
        if (!events.length || events.length < 24) return fullDomain;
  
        var timestamps = events
          .map(function(eventData) { return eventData.timestamp; })
          .filter(Number.isFinite)
          .sort(function(a, b) { return a - b; });
        if (timestamps.length < 24) return fullDomain;
  
        var lower = timestamps[Math.floor(timestamps.length * 0.02)];
        var upper = timestamps[Math.max(Math.ceil(timestamps.length * 0.98) - 1, 0)];
        var fullSpan = fullDomain[1].getTime() - fullDomain[0].getTime();
        var focusSpan = upper - lower;
  
        if (!Number.isFinite(focusSpan) || focusSpan <= 0 || focusSpan > fullSpan * 0.72) return fullDomain;
  
        var padding = Math.max(7 * 24 * 60 * 60 * 1000, focusSpan * 0.06);
        return [
          new Date(Math.max(fullDomain[0].getTime(), lower - padding)),
          new Date(Math.min(fullDomain[1].getTime(), upper + padding))
        ];
      }
  
      function zoomTransformForDomain(baseXScale, domain, innerWidth) {
        var x0 = baseXScale(domain[0]);
        var x1 = baseXScale(domain[1]);
        var span = x1 - x0;
        if (!Number.isFinite(span) || span <= 0) return d3.zoomIdentity;
  
        var scale = innerWidth / span;
        if (!Number.isFinite(scale) || scale <= 0) return d3.zoomIdentity;
  
        return d3.zoomIdentity.translate(-x0 * scale, 0).scale(scale);
      }
  
      function renderLaneLegend() {
        var legend = document.getElementById('timeline_lane_legend');
        if (!legend) return;
  
        legend.innerHTML = AGGREGATE_CONFIG.map(function(config) {
          return '' +
            '<span class="timeline-lane-legend-item">' +
              '<span class="timeline-lane-legend-swatch" data-timeline-color="' + escapeHtml(config.color) + '"></span>' +
              '<span>' + escapeHtml(config.label) + '</span>' +
            '</span>';
        }).join('');
      }
  
      function timelineChartHeight(surface) {
        var viewportHeight = window.visualViewport && window.visualViewport.height
          ? window.visualViewport.height
          : (window.innerHeight || 900);
        var footer = document.querySelector('footer');
        var surfaceTop = surface ? surface.getBoundingClientRect().top : 220;
        var footerHeight = footer ? footer.getBoundingClientRect().height : 0;
        var availableBottom = viewportHeight - footerHeight - 12;
  
        return Math.max(420, Math.min(980, Math.floor(availableBottom - surfaceTop - 20)));
      }
  
      function clearTooltip() {
        if (!tooltipNode) return;
        tooltipNode.remove();
        tooltipNode = null;
      }
  
      function countLabel(count, singular) {
        return count + ' ' + singular + (count === 1 ? '' : 's');
      }
  
      function eventTooltipHtml(eventData) {
        var sourceEvents = Array.isArray(eventData.sourceEvents) ? eventData.sourceEvents : [eventData];
        var eventCount = eventData.eventCount || sourceEvents.length || 1;
        var associationCount = eventData.associationCount || 0;
        var internalAssociationCount = eventData.internalAssociationCount || 0;
        var documentLink = eventCount === 1 && eventData.document_url
          ? '<button type="button" class="btn btn-sm btn-outline-primary me-2 mt-2 timeline-pdf-modal-link" data-pdf-url="' + escapeHtml(eventData.document_url) + '" data-pdf-title="' + escapeHtml(eventData.document_name || 'Document') + '">Document</button>'
          : '';
  
        if (eventCount > 1) {
          var eventList = sourceEvents.slice(0, 8).map(function(sourceEvent) {
            return '<div class="small mb-1"><strong>' + escapeHtml(sourceEvent.displayId) + '</strong> ' +
              escapeHtml(sourceEvent.classLabel + ' · ' + truncateText(sourceEvent.text || sourceEvent.document_name, 115)) +
              '</div>';
          }).join('');
          var remainingCount = Math.max(0, sourceEvents.length - 8);
          var remainingText = remainingCount > 0 ? '<div class="small text-muted">+' + remainingCount + ' more</div>' : '';
  
          return '' +
            '<div class="timeline-tooltip">' +
              '<div class="fw-bold mb-1">' + escapeHtml(eventData.date + ' · ' + countLabel(eventCount, 'event')) + '</div>' +
              '<div class="small text-muted mb-2">' + escapeHtml(eventData.aggregate.label + ' · ' + (eventData.categorySummary || 'Mixed categories')) + '</div>' +
              '<div class="small mb-2">' +
                '<span class="badge text-bg-primary me-1">' + escapeHtml(countLabel(eventCount, 'event')) + '</span>' +
                '<span class="badge text-bg-secondary me-1">' + escapeHtml(countLabel(associationCount, 'association')) + '</span>' +
                (internalAssociationCount ? '<span class="badge text-bg-light text-dark">' + escapeHtml(countLabel(internalAssociationCount, 'same-date link')) + '</span>' : '') +
              '</div>' +
              eventList +
              remainingText +
            '</div>';
        }
  
        return '' +
          '<div class="timeline-tooltip">' +
            '<div class="fw-bold mb-1">' + escapeHtml(eventData.displayId + ' · ' + eventData.date) + '</div>' +
            '<div class="small text-muted mb-2">' + escapeHtml(eventData.aggregate.label + ' · ' + eventData.classLabel + ' · ' + eventData.party) + '</div>' +
            '<div class="small mb-2">' +
              '<span class="badge text-bg-primary me-1">' + escapeHtml(eventData.aggregate.label) + '</span>' +
              '<span class="badge text-bg-secondary me-1">' + escapeHtml(eventData.classLabel) + '</span>' +
              '<span class="badge text-bg-light text-dark me-1">' + escapeHtml(eventData.party) + '</span>' +
              '<span class="badge text-bg-light text-dark">' + escapeHtml(countLabel(associationCount, 'association')) + '</span>' +
            '</div>' +
            '<div class="small mb-2"><strong>Caused By:</strong> ' + escapeHtml((eventData.cause_sequences || []).join(', ') || 'none') + '</div>' +
            '<div class="small mb-2"><strong>Leads To:</strong> ' + escapeHtml((eventData.effect_sequences || []).join(', ') || 'none') + '</div>' +
            '<div class="small">' + escapeHtml(truncateText(eventData.text, 340)) + '</div>' +
            '<div>' + documentLink + '</div>' +
          '</div>';
      }
  
      function associationTooltipHtml(link) {
        return '' +
          '<div class="timeline-tooltip">' +
            '<div class="fw-bold mb-1">' + escapeHtml(countLabel(link.count || 1, 'association')) + '</div>' +
            '<div class="small mb-2"><strong>Cause:</strong> ' + escapeHtml(link.source.displayId + ' · ' + truncateText(link.source.text, 150)) + '</div>' +
            '<div class="small"><strong>Effect:</strong> ' + escapeHtml(link.target.displayId + ' · ' + truncateText(link.target.text, 150)) + '</div>' +
          '</div>';
      }
  
      function positionTooltip(domEvent) {
        if (!tooltipNode || !domEvent) return;
  
        var left = domEvent.clientX + 18;
        var top = domEvent.clientY - 18;
        var nodeRect = tooltipNode.getBoundingClientRect();
        var maxLeft = Math.max(12, window.innerWidth - nodeRect.width - 12);
        var maxTop = Math.max(12, window.innerHeight - nodeRect.height - 12);
  
        tooltipNode.style.left = Math.min(Math.max(12, left), maxLeft) + 'px';
        tooltipNode.style.top = Math.min(Math.max(12, top), maxTop) + 'px';
      }
  
      function showTooltip(html, domEvent, pinned) {
        if (!tooltipNode) {
          tooltipNode = document.createElement('div');
          tooltipNode.id = 'timeline_pinned_tooltip';
          document.body.appendChild(tooltipNode);
        }
  
        tooltipNode.className = 'timeline-floating-tooltip shadow' + (pinned ? ' timeline-floating-tooltip-pinned' : '');
        tooltipNode.innerHTML = (pinned ? '<button type="button" class="btn-close timeline-pinned-tooltip-close" aria-label="Close"></button>' : '') + html;
        positionTooltip(domEvent);
      }
  
      function openTimelinePdfModal(url, title) {
        var modalElement = document.getElementById('timelinePdfModal');
        var frame = document.getElementById('timelinePdfModalFrame');
        var titleElement = document.getElementById('timelinePdfModalLabel');
        if (!modalElement || !frame || !url) return;
  
        frame.src = url;
        titleElement.textContent = title || 'PDF Preview';
  
        if (window.bootstrap && bootstrap.Modal) {
          bootstrap.Modal.getOrCreateInstance(modalElement).show();
        }
      }
  
      function bindTimelinePdfModal() {
        addTimelineListener(document, 'click', function(event) {
          var target = event.target;
          var trigger = target && target.closest ? target.closest('.timeline-pdf-modal-link') : null;
          if (!trigger) return;
  
          event.preventDefault();
          event.stopPropagation();
          clearTooltip();
          openTimelinePdfModal(trigger.dataset.pdfUrl, trigger.dataset.pdfTitle);
        }, { capture: true });
  
        addTimelineListener(document, 'click', function(event) {
          var target = event.target;
          if (target && target.closest && target.closest('.timeline-pinned-tooltip-close')) {
            event.preventDefault();
            if (chartState && chartState.clearHighlight) chartState.clearHighlight(true);
            else clearTooltip();
            return;
          }
  
          if (target && target.closest && target.closest('.timeline-floating-tooltip, .timeline-d3-node, .timeline-association-path, #timeline_zoom_reset_btn')) return;
          if (chartState && chartState.clearHighlight) chartState.clearHighlight(true);
          else clearTooltip();
        }, { capture: true });
  
        var modalElement = document.getElementById('timelinePdfModal');
        var frame = document.getElementById('timelinePdfModalFrame');
        if (modalElement && frame) {
          addTimelineListener(modalElement, 'hidden.bs.modal', function() {
            frame.removeAttribute('src');
          });
        }
      }
  
      function timelinePanelErrorHtml(title, error) {
        var message = error && error.message ? error.message : String(error || 'Unknown chart error');
        return '' +
          '<div class="alert alert-danger mb-0">' +
            '<strong>' + escapeHtml(title) + ' failed to render.</strong>' +
            '<div class="small mt-1">' + escapeHtml(message) + '</div>' +
          '</div>';
      }
  
      function updateVisibleStats(events, links, xScale) {
        var domain = xScale.domain();
        var minTime = domain[0].getTime();
        var maxTime = domain[1].getTime();
        var visibleIds = new Set();
  
        events.forEach(function(eventData) {
          if (eventData.timestamp >= minTime && eventData.timestamp <= maxTime) visibleIds.add(eventData.idKey);
        });
  
        var visibleLinks = links.filter(function(link) {
          return visibleIds.has(link.source.idKey) && visibleIds.has(link.target.idKey);
        });
        var visibleAssociationCount = visibleLinks.reduce(function(total, link) {
          return total + (link.count || 1);
        }, 0);
        visibleAssociationCount += events.reduce(function(total, eventData) {
          return visibleIds.has(eventData.idKey) ? total + (eventData.internalAssociationCount || 0) : total;
        }, 0);
  
        setTimelineText('timeline_visible_count', String(visibleIds.size));
        setTimelineText('timeline_visible_associations', String(visibleAssociationCount));
        setTimelineText('timeline_range_label', formatRangeLabel(domain));
      }
  
      function timelineSurfaceDimensions(surface) {
        var rect = surface.getBoundingClientRect();
        return {
          width: Math.max(760, Math.floor(rect.width || surface.clientWidth || 1100)),
          height: timelineChartHeight(surface)
        };
      }
  
      function shouldSkipTimelineRender(surface, payloadSignature, dimensions, force) {
        if (force || !chartState || chartState.surface !== surface) return false;
        if (chartState.payloadSignature !== payloadSignature) return false;
  
        return Math.abs(chartState.width - dimensions.width) < 18 &&
          Math.abs(chartState.height - dimensions.height) < 18;
      }
  
      function renderTimelineChart(options) {
        var force = options && options.force;
        renderLaneLegend();
  
        var surface = document.getElementById('progress_d3_timeline_visual');
        if (!surface) return;
  
        if (!d3) {
          surface.innerHTML = '<div class="alert alert-danger mb-0">D3.js failed to load for the timeline view.</div>';
          return;
        }
  
        var payloadNode = document.getElementById('case_documents_chart_payload');
        var payloadSignature = timelinePayloadText(payloadNode);
        var dimensions = timelineSurfaceDimensions(surface);
  
        if (shouldSkipTimelineRender(surface, payloadSignature, dimensions, force)) return;
  
        var timelineData = buildTimelineData();
        var events = timelineData.events;
        var links = timelineData.links;
        var previousDomain = chartState && chartState.surface === surface &&
          chartState.payloadSignature === payloadSignature && chartState.transform
          ? chartState.transform.rescaleX(chartState.baseXScale).domain()
          : null;
        var pinnedHighlight = chartState && chartState.surface === surface &&
          chartState.payloadSignature === payloadSignature ? chartState.pinnedHighlight : null;
  
        clearTooltip();
        surface.innerHTML = '';
  
        if (!events.length) {
          surface.innerHTML = '<div class="alert alert-secondary mb-0">No events available.</div>';
          setTimelineText('timeline_visible_count', '0');
          setTimelineText('timeline_visible_associations', '0');
          setTimelineText('timeline_range_label', 'No data');
          return;
        }
  
        var adjacency = buildAdjacency(events, links);
        var width = dimensions.width;
        var height = dimensions.height;
        var compact = width < 760;
        var margin = {
          top: 36,
          right: compact ? 18 : 36,
          bottom: 62,
          left: compact ? 118 : 168
        };
        var innerWidth = width - margin.left - margin.right;
        var innerHeight = height - margin.top - margin.bottom;
        var minTimestamp = d3.min(events, function(eventData) { return eventData.timestamp; });
        var maxTimestamp = d3.max(events, function(eventData) { return eventData.timestamp; });
        var domainStart = new Date(minTimestamp);
        var domainEnd = new Date(maxTimestamp);
  
        if (domainStart.getTime() === domainEnd.getTime()) {
          domainStart = d3.timeDay.offset(domainStart, -1);
          domainEnd = d3.timeDay.offset(domainEnd, 1);
        } else {
          domainStart = d3.timeDay.offset(d3.timeDay.floor(domainStart), -1);
          domainEnd = d3.timeDay.offset(d3.timeDay.ceil(domainEnd), 1);
        }
  
        surface.style.height = height + 'px';
        surface.dataset.timelineRenderedLinkCount = String(links.length);
        var clipId = 'timeline-chart-clip-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  
        var svg = d3.select(surface)
          .append('svg')
          .attr('class', 'timeline-d3-svg')
          .attr('width', width)
          .attr('height', height)
          .attr('role', 'img')
          .attr('aria-label', 'Single D3 timeline chart showing events by lane and cause effect associations');
  
        var defs = svg.append('defs');
        defs.append('clipPath')
          .attr('id', clipId)
          .append('rect')
          .attr('width', innerWidth)
          .attr('height', innerHeight + 18)
          .attr('x', 0)
          .attr('y', -9);
  
        var xScale = d3.scaleTime()
          .domain([domainStart, domainEnd])
          .range([0, innerWidth]);
        var yScale = d3.scaleBand()
          .domain(AGGREGATE_CONFIG.map(function(config) { return config.key; }))
          .range([0, innerHeight])
          .paddingInner(0.68)
          .paddingOuter(0.24);
        var baseXScale = xScale.copy();
        var initialDomain = previousDomain || focusedTimelineDomain(events, [domainStart, domainEnd]);
        var initialTransform = zoomTransformForDomain(baseXScale, initialDomain, innerWidth);
        // Long date ranges can still zoom down to a minute-wide window.
        var maximumZoom = Math.max(1000, (domainEnd.getTime() - domainStart.getTime()) / 60000);
        var laneCenter = function(key) {
          return yScale(key) + (yScale.bandwidth() / 2);
        };
        var eventY = function(eventData) {
          return laneCenter(eventData.aggregateKey) + (eventData.clusterOffset || 0);
        };
        var tickCount = compact ? 5 : Math.max(6, Math.min(12, Math.floor(innerWidth / 95)));
  
        var chartGroup = svg.append('g')
          .attr('class', 'timeline-plot')
          .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        chartGroup.append('rect')
          .attr('class', 'timeline-zoom-surface')
          .attr('width', innerWidth)
          .attr('height', innerHeight)
          .attr('fill', 'transparent');
        var laneLayer = chartGroup.append('g').attr('class', 'timeline-lane-layer');
        var gridLayer = chartGroup.append('g').attr('class', 'timeline-grid-layer');
        var linkLayer = chartGroup.append('g').attr('class', 'timeline-link-layer').attr('clip-path', 'url(#' + clipId + ')');
        var nodeLayer = chartGroup.append('g').attr('class', 'timeline-node-layer').attr('clip-path', 'url(#' + clipId + ')');
        var yAxisLayer = chartGroup.append('g').attr('class', 'timeline-y-axis-layer');
        var xAxisLayer = chartGroup.append('g')
          .attr('class', 'timeline-x-axis-layer')
          .attr('transform', 'translate(0,' + innerHeight + ')');
  
        laneLayer.selectAll('.timeline-lane-band')
          .data(AGGREGATE_CONFIG)
          .enter()
          .append('rect')
          .attr('class', 'timeline-lane-band')
          .attr('x', 0)
          .attr('y', function(config) { return yScale(config.key) - 20; })
          .attr('width', innerWidth)
          .attr('height', Math.max(42, yScale.bandwidth() + 40));
  
        laneLayer.selectAll('.timeline-lane-line')
          .data(AGGREGATE_CONFIG)
          .enter()
          .append('line')
          .attr('class', 'timeline-lane-line')
          .attr('x1', 0)
          .attr('x2', innerWidth)
          .attr('y1', function(config) { return laneCenter(config.key); })
          .attr('y2', function(config) { return laneCenter(config.key); });
  
        yAxisLayer.selectAll('.timeline-lane-label')
          .data(AGGREGATE_CONFIG)
          .enter()
          .append('text')
          .attr('class', 'timeline-lane-label')
          .attr('x', -18)
          .attr('y', function(config) { return laneCenter(config.key) + 4; })
          .attr('text-anchor', 'end')
          .text(function(config) { return config.label; });
  
        yAxisLayer.selectAll('.timeline-lane-label-swatch')
          .data(AGGREGATE_CONFIG)
          .enter()
          .append('rect')
          .attr('class', 'timeline-lane-label-swatch')
          .attr('x', -12)
          .attr('y', function(config) { return laneCenter(config.key) - 6; })
          .attr('width', 8)
          .attr('height', 12)
          .attr('rx', 2)
          .attr('fill', function(config) { return config.color; });
  
        function linkPath(link, currentXScale) {
          var x1 = currentXScale(link.source.dateObject);
          var y1 = eventY(link.source);
          var x2 = currentXScale(link.target.dateObject);
          var y2 = eventY(link.target);
          var routeOffset = ((link.routeIndex % 9) - 4) * 3.5;
  
          if (link.source.aggregateKey === link.target.aggregateKey) {
            var midX = x1 + ((x2 - x1) / 2);
            var arc = (x2 >= x1 ? -1 : 1) * (34 + ((link.routeIndex % 5) * 8));
            return 'M ' + x1 + ' ' + y1 + ' C ' + midX + ' ' + (y1 + arc + routeOffset) + ', ' + midX + ' ' + (y2 + arc + routeOffset) + ', ' + x2 + ' ' + y2;
          }
  
          var controlY = ((y1 + y2) / 2) + routeOffset;
          return 'M ' + x1 + ' ' + y1 + ' C ' + x1 + ' ' + controlY + ', ' + x2 + ' ' + controlY + ', ' + x2 + ' ' + y2;
        }
  
        var linkSelection = linkLayer.selectAll('.timeline-association-path')
          .data(links, function(link) { return link.id; })
          .enter()
          .append('path')
          .attr('class', 'timeline-association-path')
          .attr('fill', 'none')
          .attr('stroke', function(link) { return link.color; })
          .attr('stroke-opacity', 0.26)
          .attr('stroke-linecap', 'round')
          .attr('stroke-linejoin', 'round')
          .attr('stroke-width', function(link) { return Math.min(3.8, 1.25 + (Math.sqrt(link.count || 1) * 0.42)); })
          .attr('vector-effect', 'non-scaling-stroke')
          .style('fill', 'none')
          .style('stroke', function(link) { return link.color; })
          .style('display', 'inline')
          .style('visibility', 'visible')
          .style('opacity', 1)
          .style('pointer-events', 'stroke')
          .attr('d', function(link) { return linkPath(link, xScale); });
  
        function nodeRadius(eventData) {
          var eventCount = eventData.eventCount || 1;
          var associationCount = eventData.associationCount || 0;
  
          if (eventCount > 1) return Math.min(38, 12 + (Math.sqrt(eventCount) * 5.2));
          return Math.min(30, 10 + (Math.sqrt(associationCount) * 4.2));
        }
  
        var nodeSelection = nodeLayer.selectAll('.timeline-d3-node')
          .data(events, function(eventData) { return eventData.idKey; })
          .enter()
          .append('circle')
          .attr('class', 'timeline-d3-node')
          .attr('tabindex', '0')
          .attr('role', 'button')
          .attr('aria-label', function(eventData) {
            return eventData.date + ' ' + countLabel(eventData.eventCount || 1, 'event') + ' ' + countLabel(eventData.associationCount || 0, 'association');
          })
          .attr('r', nodeRadius)
          .attr('fill', function(eventData) { return eventData.aggregate.color; })
          .attr('stroke', '#f0fcfd')
          .attr('stroke-width', 1.35);
  
        nodeSelection.append('title')
          .text(function(eventData) {
            return [
              eventData.date + ' · ' + countLabel(eventData.eventCount || 1, 'event'),
              eventData.aggregate.label + ' · ' + (eventData.categorySummary || eventData.classLabel) + ' · ' + countLabel(eventData.associationCount || 0, 'association'),
              truncateText(eventData.text, 180)
            ].join('\n');
          });
  
        var labelSelection = nodeLayer.selectAll('.timeline-d3-node-label')
          .data(events.filter(function(eventData) { return eventData.eventCount > 1 || eventData.degree > 0; }), function(eventData) { return eventData.idKey; })
          .enter()
          .append('text')
          .attr('class', 'timeline-d3-node-label')
          .attr('dy', function(eventData) { return -nodeRadius(eventData) - 7; })
          .attr('text-anchor', 'middle')
          .text(function(eventData) { return eventData.pointLabel; });
  
        function applyHighlightForEvent(eventData) {
          var connected = adjacency.get(eventData.idKey) || new Set([eventData.idKey]);
  
          nodeSelection
            .classed('is-muted', function(candidate) { return !connected.has(candidate.idKey); })
            .classed('is-highlighted', function(candidate) { return candidate.idKey === eventData.idKey; })
            .classed('is-related', function(candidate) { return candidate.idKey !== eventData.idKey && connected.has(candidate.idKey); });
  
          labelSelection
            .classed('is-muted', function(candidate) { return !connected.has(candidate.idKey); })
            .classed('is-visible', function(candidate) { return connected.has(candidate.idKey); });
  
          linkSelection
            .classed('is-muted', function(link) { return link.source.idKey !== eventData.idKey && link.target.idKey !== eventData.idKey; })
            .classed('is-highlighted', function(link) { return link.source.idKey === eventData.idKey || link.target.idKey === eventData.idKey; });
        }
  
        function applyHighlightForLink(activeLink) {
          var connected = new Set([activeLink.source.idKey, activeLink.target.idKey]);
  
          nodeSelection
            .classed('is-muted', function(candidate) { return !connected.has(candidate.idKey); })
            .classed('is-highlighted', function(candidate) { return candidate.idKey === activeLink.source.idKey || candidate.idKey === activeLink.target.idKey; })
            .classed('is-related', false);
  
          labelSelection
            .classed('is-muted', function(candidate) { return !connected.has(candidate.idKey); })
            .classed('is-visible', function(candidate) { return connected.has(candidate.idKey); });
  
          linkSelection
            .classed('is-muted', function(link) { return link.id !== activeLink.id; })
            .classed('is-highlighted', function(link) { return link.id === activeLink.id; });
        }
  
        function pinHighlight(value) {
          pinnedHighlight = value;
          chartState.pinnedHighlight = value;
        }

        function clearHighlight(force) {
          if (pinnedHighlight && force !== true) return;
          pinHighlight(null);
          nodeSelection.classed('is-muted is-highlighted is-related', false);
          labelSelection.classed('is-muted is-visible', false);
          linkSelection.classed('is-muted is-highlighted', false);
          clearTooltip();
        }
  
        nodeSelection
          .on('mouseenter', function(event, eventData) {
            if (pinnedHighlight) return;
            applyHighlightForEvent(eventData);
            showTooltip(eventTooltipHtml(eventData), event, false);
          })
          .on('mousemove', function(event) {
            if (!tooltipNode || tooltipNode.classList.contains('timeline-floating-tooltip-pinned')) return;
            positionTooltip(event);
          })
          .on('mouseleave', clearHighlight)
          .on('click', function(event, eventData) {
            event.preventDefault();
            event.stopPropagation();
            pinHighlight({ event: eventData });
            applyHighlightForEvent(eventData);
            showTooltip(eventTooltipHtml(eventData), event, true);
          })
          .on('keydown', function(event, eventData) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            pinHighlight({ event: eventData });
            applyHighlightForEvent(eventData);
            var syntheticEvent = {
              clientX: width / 2,
              clientY: height / 2
            };
            showTooltip(eventTooltipHtml(eventData), syntheticEvent, true);
          });
  
        linkSelection
          .on('click', function(event, link) {
            event.preventDefault();
            event.stopPropagation();
            pinHighlight({ link: link });
            applyHighlightForLink(link);
            showTooltip(associationTooltipHtml(link), event, true);
          });
  
        var xAxis = d3.axisBottom(xScale)
          .ticks(tickCount);
  
        function xAxisTickFormatter(currentXScale) {
          var domain = currentXScale.domain();
          var spanDays = (domain[1].getTime() - domain[0].getTime()) / (24 * 60 * 60 * 1000);
  
          if (spanDays > 730) return d3.timeFormat('%Y');
          if (spanDays > 90) return d3.timeFormat('%b %Y');
          if (spanDays < 1 / 24) return d3.timeFormat('%H:%M:%S');
          if (spanDays < tickCount) return d3.timeFormat('%b %d %H:%M');
          return d3.timeFormat('%b %d');
        }
  
        function drawGridAndAxis(currentXScale) {
          var ticks = currentXScale.ticks(tickCount);
  
          gridLayer.selectAll('.timeline-x-grid-line')
            .data(ticks, function(tick) { return tick.getTime(); })
            .join(
              function(enter) {
                return enter.append('line')
                  .attr('class', 'timeline-x-grid-line')
                  .attr('y1', 0)
                  .attr('y2', innerHeight);
              },
              function(update) { return update; },
              function(exit) { return exit.remove(); }
            )
            .attr('x1', function(tick) { return currentXScale(tick); })
            .attr('x2', function(tick) { return currentXScale(tick); });
  
          xAxisLayer.call(xAxis.scale(currentXScale).tickFormat(xAxisTickFormatter(currentXScale)));
          xAxisLayer.select('.domain').attr('class', 'timeline-axis-domain');
          xAxisLayer.selectAll('text').attr('class', 'timeline-axis-label');
          xAxisLayer.selectAll('line').attr('class', 'timeline-axis-tick');
        }
  
        function updatePositions(currentXScale) {
          linkSelection.attr('d', function(link) { return linkPath(link, currentXScale); });
          nodeSelection.attr('transform', function(eventData) {
            return 'translate(' + currentXScale(eventData.dateObject) + ',' + eventY(eventData) + ')';
          });
          labelSelection.attr('transform', function(eventData) {
            return 'translate(' + currentXScale(eventData.dateObject) + ',' + eventY(eventData) + ')';
          });
          drawGridAndAxis(currentXScale);
          updateVisibleStats(events, links, currentXScale);
        }
  
        var zoomBehavior = d3.zoom()
          .scaleExtent([0.01, maximumZoom])
          .extent([[0, 0], [innerWidth, innerHeight]])
          .filter(function(event) {
            if (event.type === 'wheel') return true;
            return !event.target.closest || !event.target.closest('.timeline-d3-node, .timeline-association-path, .timeline-pdf-modal-link');
          })
          .on('zoom', function(event) {
            var transformedXScale = event.transform.rescaleX(baseXScale);
            chartState.transform = event.transform;
            clearTooltip();
            updatePositions(transformedXScale);
          });
  
        chartGroup.call(zoomBehavior).on('dblclick.zoom', null);
  
        chartState = {
          surface: surface,
          svg: svg,
          zoom: zoomBehavior,
          baseXScale: baseXScale,
          update: updatePositions,
          clearHighlight: clearHighlight,
          pinnedHighlight: pinnedHighlight,
          payloadSignature: payloadSignature,
          width: width,
          height: height,
          resetZoom: function() {
            chartGroup.transition().duration(180).call(zoomBehavior.transform, d3.zoomIdentity);
          }
        };
  
        if (initialTransform.k !== 1 || initialTransform.x !== 0) {
          chartGroup.call(zoomBehavior.transform, initialTransform);
        } else {
          updatePositions(xScale);
        }
        if (pinnedHighlight) {
          if (pinnedHighlight.event) applyHighlightForEvent(pinnedHighlight.event);
          else applyHighlightForLink(pinnedHighlight.link);
        }
      }
  
      function destroyTimelineChart() {
        clearTooltip();
        var surface = document.getElementById('progress_d3_timeline_visual');
        if (surface) surface.innerHTML = '';
        chartState = null;
      }
  
      function bindTimelineRender() {
        bindTimelinePdfModal();
        renderTimelineChart();
  
        addTimelineListener(document, 'turbo:before-cache', destroyTimelineChart);
        addTimelineListener(window, 'resize', function() {
          window.clearTimeout(resizeRenderTimeout || window.caseTimelineD3ResizeTimeout);
          resizeRenderTimeout = window.setTimeout(function() {
            window.caseTimelineD3ResizeTimeout = null;
            renderTimelineChart({ force: false });
          }, 160);
          window.caseTimelineD3ResizeTimeout = resizeRenderTimeout;
        });
        addTimelineListener(document.getElementById('timeline_zoom_reset_btn'), 'click', function() {
          if (chartState && chartState.resetZoom) chartState.resetZoom();
        });
        addTimelineListener(document, 'case-document:refresh', refreshTimelinePayloadFromServer);
        addTimelineListener(document, 'keydown', function(event) {
          if (event.key === 'Escape') {
            clearTooltip();
            if (chartState && chartState.clearHighlight) chartState.clearHighlight(true);
          }
        });
      }
  
      try {
        bindTimelineRender();
      } catch (error) {
        console.error('Timeline render failed', error);
        var surface = document.getElementById('progress_d3_timeline_visual');
        if (surface) surface.innerHTML = timelinePanelErrorHtml('Timeline chart', error);
      }
    })();
  }

  document.addEventListener("turbo:load", initializeCaseTimeline);
  document.addEventListener("turbo:frame-load", initializeCaseTimeline);
  document.addEventListener("turbo:render", initializeCaseTimeline);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeCaseTimeline, { once: true });
  } else {
    initializeCaseTimeline();
  }
